import ChevronDownIcon from "@redotech/redo-icons/chevron-down.svg";
import ChevronUpIcon from "@redotech/redo-icons/chevron-up.svg";
import { Icon } from "@redotech/redo-web/icon";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as showMoreLessButtonCss from "./show-more-less-button.module.css";

export interface ShowMoreLessButtonProps {
  isExpanded: boolean;
  onToggle: () => void;
  hasMore: boolean;
  totalCount?: number;
  visibleCount?: number;
  className?: string;
}

export const ShowMoreLessButton = memo(function ShowMoreLessButton({
  isExpanded,
  onToggle,
  hasMore,
  totalCount,
  visibleCount,
  className,
}: ShowMoreLessButtonProps) {
  if (!hasMore) {
    return null;
  }

  const buttonText = isExpanded
    ? "Show Less"
    : totalCount && visibleCount
      ? `Show More (${totalCount - visibleCount})`
      : "Show More";

  return (
    <div className={`${showMoreLessButtonCss.container} ${className || ""}`}>
      <button
        aria-expanded={isExpanded}
        aria-label={buttonText}
        className={showMoreLessButtonCss.button}
        onClick={onToggle}
      >
        <Text fontSize="sm" fontWeight="medium" textColor="secondary">
          {buttonText}
        </Text>
        <Icon
          arbiterIconSvg={isExpanded ? ChevronUpIcon : ChevronDownIcon}
          color="brand"
          size="extra-small"
          variant="primary modern"
        />
      </button>
    </div>
  );
});
